import * as d3 from 'd3';
import Chart from '../chart';

export default class TinyEvolutionChart extends Chart {
  // First step of the D3 rendering.
  create() {
    this.svg = super.createRoot();
    this.main = this.svg.append('g')
      .attr('class', 'main')
      .attr('transform', `translate(${this.props.margin.left},${this.props.height / 2})`);

    this.background = this.main.append('g')
      .attr('class', 'background')

    this.delta = this.main.append('g')
      .attr('class', 'delta')
      .append('rect')

    this.past = this.main.append('g')
      .attr('class', 'past')
      .append('circle')

    this.pastLabel = this.main.append('g')
      .append('text')

    this.now = this.main.append('g')
      .attr('class', 'now')
      .append('circle')

    this.nowLabel = this.main.append('g')
      .append('text')

    this.nameLabel = this.main.append('g')
      .append('text')

    this.timeLabel = this.main.append('g')

    this.timeLabelPast = this.timeLabel
      .append('text')
      .style('visibility', 'hidden')

    this.timeLabelNow = this.timeLabel
      .append('text')
      .style('visibility', 'hidden')
  
    this.barHeight = 2;
  }

  // Main D3 rendering, that should be redone when the data updates.
  update(state) {
    this._drawChart(state)
  }

  _drawChart(state) {
    const { now, past, max, label, showLabel } = state
    const x = d3.scaleLinear()
      .range([0, this.props.width])
      .domain([0, max])

    this.background.append('rect')
      .attr('x', 0)
      .attr('y', -this.barHeight / 2)
      .attr('width', this.props.width)
      .attr('height', this.barHeight)
      .attr('rx', this.barHeight / 2)
      .attr('ry', this.barHeight / 2)
      .style('fill', 'lightgrey')

    this.delta
      .attr('x', x(past))
      .attr('y', -2.5)
      .attr('width', x(now) - x(past))
      .attr('height', 5)
      .attr('rx', 4)
      .attr('ry', 4)
      .style('fill', '#cacaca')

    this.past
      .attr('fill', '#cacaca')
      .attr('stroke', 'white')
      .attr('stroke-width', 2)
      .attr('cy', 0)
      .attr('cx', x(past))
      .attr('r', 7.5)

    this.pastLabel
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "middle")
      .attr("x", x(past))
      .attr("y", -12)
      .attr('font-size', 10)
      .attr('fill', 'grey')
      .text(`${Math.round(past*1000)/10}%`)

    const thresholds = [0.06, 0.07, 0.08, 0.09, 0.10, 0.11, 0.12, 0.14, 0.16];
    const scheme = d3.schemeRdPu[thresholds.length]
    const colorScale = d3.scaleThreshold()
      .domain(thresholds)
      .range(scheme)

    this.now
      .attr('fill', d => colorScale(now))
      .attr('stroke', 'white')
      .attr('stroke-width', 2)
      .attr('cy', 0)
      .attr('cx', x(now))
      .attr('r', 7.5)
    
    this.nowLabel
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "middle")
      .attr('font-size', 10)
      .attr("x", x(now))
      .attr("y", -12)
      .text(`${Math.round(now*1000)/10}%`)

    
    this.nameLabel
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "start")
      .attr('font-size', 12)
      .attr("x", 0)
      .attr("y", -12)
      .text(label)

    this.timeLabelPast
      .style('visibility', showLabel ? 'visible' : 'hidden')
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "end")
      .attr("x", x(past) - 10)
      .attr("y", 5)
      .attr('font-size', 10)
      .attr('fill', 'grey')
      .style('text-shadow', 'white -2px -2px 0px, white 2px -2px 0px, white -2px 2px 0px, white 2px 2px 0px')
      .text(`2010`)

    this.timeLabelNow
      .style('visibility', showLabel ? 'visible' : 'hidden')
      .attr("alignment-baseline", "middle")
      .attr("text-anchor", "start")
      .attr("x", x(now) + 10)
      .attr("y", 5)
      .attr('font-size', 10)
      .attr('fill', 'grey')
      .style('text-shadow', 'white -2px -2px 0px, white 2px -2px 0px, white -2px 2px 0px, white 2px 2px 0px')
      .text(`2018`)
      
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/TinyEvolutionChart/TinyEvolutionChart.js